export default __webpack_public_path__ + "static/media/figure3.f3b09803.csv";